import api from "@/lib/api";

const KEY = "lbm_offline_volunteers";

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

function saveQueue(q) {
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new Event("lbm-queue-change"));
}

export function enqueueVolunteer(payload) {
  const q = getQueue();
  q.push({ ...payload, _queuedAt: new Date().toISOString(), _id: crypto.randomUUID() });
  saveQueue(q);
}

let inFlight = false;

export async function syncQueue() {
  if (inFlight) return { synced: 0, remaining: getQueue().length };
  if (!navigator.onLine) return { synced: 0, remaining: getQueue().length };
  inFlight = true;
  try {
    let q = getQueue();
    let synced = 0;
    for (const item of [...q]) {
      try {
        const { _queuedAt, _id, ...payload } = item;
        await api.post("/volunteers", payload);
        q = q.filter((x) => x._id !== _id);
        saveQueue(q);
        synced++;
      } catch (e) {
        // stop on first failure (likely offline again); keep the rest queued
        if (!navigator.onLine) break;
      }
    }
    return { synced, remaining: getQueue().length };
  } finally {
    inFlight = false;
  }
}
